import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ReactEcharts from 'echarts-for-react';
import { useTranslation } from 'react-i18next'
import get from 'lodash/get';

import Select from '../../common/inputs/Select';
import useStyles from './styles';

const QuestionPieChart = ({ data }) => {
  const [selectedQuestion, setSelectedQuestion] = useState('0');
  const { t } = useTranslation(['translation']);
  const classes = useStyles();

  const answers = get(data[selectedQuestion], 'answers', [])
    .map((a) => ({ name: a.name, value: a.count }));

  const options = {
    legend: {
      show: true,
      icon: 'circle',
      orient: 'vertical',
      left: 'right',
      formatter: (name) => name.length > 30 ? `${name.slice(0, 27)}...` : name,
      textStyle: {
        color: '#647276',
      }
    },
    backgroundColor: 'white',
    series: {
      type: 'pie',
      center: ['40%', '45%'],
      radius: ['62%', '72%'],
      avoidLabelOverlap: false,
      label: {
        show: false,
        position: 'center',
        fontSize: 12,
        color: '#647276',
        formatter: (params) => `{b|${params.name}} \n {d|${t('COMMON.INTL_PERCENT', { value: params.percent / 100 })}} \n {c|${t('QUESTIONNAIRE.ANSWER_WITH_COUNT', { count: params.value })}}`,
        fontFamily: 'Poppins, sans-serif',
      },
      emphasis: {
        label: {
          show: true,
          rich: {
            d: {
              fontSize: 48,
              fontWeight: 300,
              padding: [15, 0],
            },
          },
        }
      },
      labelLine: {
        show: false,
      },
      data: answers,
    },
  };

  const questions = data.map(({ question }, idx) => ({ value: idx.toString(), label: question }));

  return (
    <div className={classes.container}>
      <div className={classes.headerContainer}>
        <Select
          id="single-choice"
          value={questions.length ? selectedQuestion : null}
          setFieldValue={(_, value) => setSelectedQuestion(value)}
          options={questions}
          iconName="name"
        />
      </div>
      <ReactEcharts
        option={options}
        notMerge
        style={{
          width: '100%',
          height: '100%',
          paddingTop: '60px',
          paddingRight: '20px'
        }}
      />
    </div>
  );
};

QuestionPieChart.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({
    question: PropTypes.string.isRequired,
    answers: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string.isRequired,
      count: PropTypes.number.isRequired,
    })).isRequired,
  })).isRequired,
};

export default QuestionPieChart;
